// hooks/useLeafletLocale.js
import { useEffect } from 'react';
import { leafletDrawLocales } from '../utils/leafletDrawLocales';
import L from 'leaflet';
import 'leaflet-draw';
import i18n from '../i18n';

const defaultDrawLocal = { ...L.drawLocal };

export const useLeafletLocale = () => {
  useEffect(() => {
    if (i18n.language === 'ar') {
      L.drawLocal = leafletDrawLocales['ar'];
    }else{
      L.drawLocal = defaultDrawLocal; 
    }
  }, [i18n.language]);
};
